module.exports = __webpack_public_path__ + "static/media/w (34).dcc8b8b7.jpg";